import { NavLink, Outlet } from "react-router-dom";
import { Copyright, FolderTree, Gem, Palette, Store, Tags, Truck } from "lucide-react";
import { cn } from "@/lib/cn";

/**
 * Configuracion con secciones. Cada una edita un grupo distinto de columnas
 * de la misma fila de ajustes, asi que dos personas en secciones distintas no
 * se pisan lo que la otra guarda.
 */
const SECCIONES = [
  { to: "/configuracion/categorias", label: "Categorías", icon: FolderTree, group: "Catálogo", ready: true },
  { to: "/configuracion/marcas", label: "Marcas", icon: Copyright, group: "Catálogo", ready: true },
  { to: "/configuracion/atributos", label: "Atributos", icon: Tags, group: "Catálogo", ready: true },
  { to: "/configuracion/tienda", label: "Identidad", icon: Palette, group: "Tienda", ready: true },
  { to: "/configuracion/comercial", label: "Comercial", icon: Store, group: "Tienda", ready: true },
  { to: "/configuracion/entrega", label: "Entrega", icon: Truck, group: "Tienda", ready: true },
  { to: "/configuracion/plan", label: "Tu plan", icon: Gem, group: "Cuenta", ready: true },
];

export function SettingsPage() {
  return (
    <div className="flex flex-col gap-3">
      <h1 className="text-head font-semibold tracking-tight">Configuración</h1>

      <div className="grid gap-3 lg:grid-cols-[200px_minmax(0,1fr)]">
        <nav className="flex gap-1 overflow-x-auto lg:flex-col lg:overflow-visible">
          {SECCIONES.map((s) => {
            const Icon = s.icon;
            return (
              <NavLink
                key={s.to}
                to={s.to}
                className={({ isActive }) =>
                  cn(
                    "flex shrink-0 items-center gap-2 rounded-md px-2.5 py-2 text-ui transition-colors",
                    isActive
                      ? "bg-accent-soft font-semibold text-accent"
                      : "text-ink-2 hover:bg-sunk hover:text-ink",
                    !s.ready && "opacity-50",
                  )
                }
              >
                <Icon className="size-[15px] shrink-0" strokeWidth={1.8} />
                {s.label}
              </NavLink>
            );
          })}
        </nav>

        <div className="min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
